/* Vuex mutations types for module App */
export const TOGGLE_PENDING_ASYNC_STORE_ACTIONS = 'TOGGLE_PENDING_ASYNC_STORE_ACTIONS';
export const SHOW_INFORMATION_MODAL = 'SHOW_INFORMATION_MODAL';
export const CLOSE_INFORMATION_MODAL = 'CLOSE_INFORMATION_MODAL';
export const SHOW_COOKIE_BAR = 'SHOW_COOKIE_BAR';
export const CLOSE_COOKIE_BAR = 'CLOSE_COOKIE_BAR';
